// 正则常量定义
// ! 注意：在使用处，编译国际化 例：i18n.t(RULE_7_TEXT, { x: 1, y: 30 })

// import i18n from '../i18n';

// // 验证 6-16任意字符 （密码）
// export const RULE_1 = /^.{6,16}$/;
// export const RULE_1_TEXT = 'input_rule_text_please_enter_x_y_characters_of_any_character';

// // 邮箱 请输入正确的邮箱格式
// export const RULE_2 = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
// export const RULE_2_TEXT = 'input_rule_text_please_enter_the_correct_mailbox_format';

// // 数字 5-20
// export const RULE_3 = /^\d{5,20}$/;
// export const RULE_3_TEXT = 'input_rule_text_please_enter_x_y_digit_characters';

// // 数字字母 最少一个（名字）
// export const RULE_4 = /^[A-Za-z0-9]+$/;
// export const RULE_4_TEXT = 'input_rule_text_please_enter_at_least_x_digit_or_english_character';

// // 图片校验
// export const RULE_5 = /image\/\w+/;
// export const RULE_5_TEXT = 'input_rule_text_please_upload_the_correct_picture_format';

// // 数字 长度5-20
// export const RULE_6 = /^[0-9]{5,20}$/;
// export const RULE_6_TEXT = 'input_rule_text_please_enter_x_y_numbers_or_horizontal_lines';

// // 暂时只限制1-30位
// export const RULE_7 = /^.{1,30}$/;
// export const RULE_7_TEXT = 'input_rule_text_please_enter_x_y_characters_of_any_character';


// // 性别 只能为 0 1 2
// export const RULE_8 = /^[0-2]$/;

// // 名字 数字字母6-20
// export const RULE_9 = /^.{6,20}$/;
// export const RULE_9_TEXT = 'input_rule_text_please_enter_x_y_characters_of_any_character';

// // 最少一个字符
// export const RULE_11 = /^.+$/;
// export const RULE_11_TEXT = 'input_rule_text_please_enter_x_characters_of_any_character';

// // 由数字、26个英文字母或者下划线组成的字符串
// export const RULE_12 = /^\w+$/;
// export const RULE_12_TEXT = 'input_rule_text_please_enter_at_least_x_number_english_letter_or_underscore';

// // 匹配中文字符
// export const RULE_13 = /^[\u4e00-\u9fa5]$/;
// export const RULE_13_TEXT = 'input_rule_text_please_enter_x_y_Chinese_characters';

// // 暂时只限制1-30位
// export const RULE_14 = /^[\u4e00-\u9fa5_A-Za-z0-9]{1,30}$/;
// export const RULE_14_TEXT = 'input_rule_text_please_enter_x_y_chinese_or_numbers_or_letters';

// // 税务地址省份正则：两位大写字母
// export const RULE_15 = /^[A-Z]{2}$/;
// export const RULE_15_TEXT = 'input_rule_text_please_enter_x_upper_case_letters';

// // 税务地址国家正则：全大写字母
// export const RULE_16 = /^[A-Z]+$/;
// export const RULE_16_TEXT = 'input_rule_text_please_enter_upper_case_letters';

// // 增值税号正则：11位数字，第一位0开头
// export const RULE_17 = /^[0]\d{10}$/;
// export const RULE_17_TEXT = 'input_rule_text_please_enter_x_numbers_start_with_y';

// // 税务注册号正则：（16位数字或字母组成，字母必须大写，至少包含一个字母或数字） 或 （11位数字，第一位0开头）
// export const RULE_18 = /(?=.*[0-9])(?=.*[A-Z])^[0-9A-Z]{16}$|^[0]\d{10}$/;
// export const RULE_18_TEXT = 'input_rule_text_please_enter_x_numbers_or_letters_at_least_y_numbers_or_letters';

// // 邮编正则：5位数字
// export const RULE_19 = /^\d{5}$/;
// export const RULE_19_TEXT = 'input_rule_text_please_enter_x_numbers';

// // 邮编正则：5位数字
// export const RULE_20 = /^\d{6}$/;
// export const RULE_20_TEXT = 'input_rule_text_please_enter_x_numbers';

// // 邮编正则：5位数字
// export const RULE_21 = /\S/;
// export const RULE_21_TEXT = 'input_rule_text_required';

// // 验证码正则
// export const RULE_22 = /^\d{6}$/;
// export const RULE_22_TEXT = 'input_rule_v_code_text';

// // 数字或字母5-12位
// export const RULE_23 = /^[A-Za-z0-9]{5,12}$/;
// export const RULE_23_TEXT = '数字或字母5-12位';


// 基础校验信息
const BASE_CHECK_TYPE: { [key: string]: { regular: RegExp, helperText: string, i18nRule?: object } } = {
    // 中英文数字,中间只能有一个空格,首尾不能有空格
    // 税率名称
    nickname: {
        regular: /^([A-Za-z0-9\u4e00-\u9fa5\-_]+\\s?)*[A-Za-z0-9\u4e00-\u9fa5\-_]$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character'
    },
    // 数字 长度5-20 （手机）
    phone: {
        regular: /^[0-9+]([-]?[0-9]){5,20}$/,
        helperText: 'input_rule_text_please_enter_x_y_numbers_or_horizontal_lines',
        i18nRule: { x: 6, y: 21 }
    },
    email: {
        regular: /^$|^[A-Za-z0-9]+([_.-][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/,
        helperText: 'input_rule_text_please_enter_the_correct_mailbox_format'
    },
    // 暂时只限制6-20位
    password: {
        regular: /^.{6,20}$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character',
        i18nRule: { x: 6, y: 20 }
    },
    // 至少一位
    name: {
        regular: /^.{1,}$/,
        helperText: 'input_rule_text_required'
    },
    printName: {
        regular: /(^([A-Za-z0-9\u4e00-\u9fa5]+\\s?)*[A-Za-z0-9\u4e00-\u9fa5]$)|(^$)/,
        helperText: 'input_rule_text_required'
    },
    // 税率名称（展示）| 名称（员工）
    staffName: {
        regular: /(^([A-Za-z0-9\u4e00-\u9fa5]+\\s?)*[A-Za-z0-9\u4e00-\u9fa5]$)|(^$)/,
        helperText: 'input_rule_text_required'
    },
    // 中文英文数字
    optionalName: {
        regular: /^[\u4e00-\u9fa5_A-Za-z0-9]{0,30}$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character',
        i18nRule: { x: 0, y: 30 }
    },
    description: {
        regular: /^.{0,255}$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character',
        i18nRule: { x: 0, y: 255 }
    },
    // 意大利增值税号正则 仅为数字及字母16位或者11位纯数字
    vatNumber: {
        regular: /^([A-Za-z0-9]{16,16}|[0-9]{11,11})$/,
        helperText: 'input_rule_text_please_enter_11_numbers_or_16_numbers_or_letters',
    },
    // 西班牙增值税号正则 9位数字
    spainVatNumber: {
        regular: /^(([A-Za-z][0-9]{7}[A-Za-z])|([0-9]{8}[A-Za-z])|([A-Za-z][0-9]{8}))$/,
        helperText: 'general_text_spain_vat_number_invalid_format_text',
    },
    // 邮编
    zipCode: {
        regular: /^[0-9]{5,5}$/,
        helperText: 'input_rule_text_please_enter_x_numbers',
        i18nRule: { x: 5 }
    },
    // 收件人代码
    recipientCode: {
        regular: /^[A-Za-z0-9]{7,7}$/,
        helperText: 'input_rule_text_please_enter_x_numbers_or_letters',
        i18nRule: { x: 7 }
    },
    // 税控码 税务注册号正则：（16位数字或字母组成，字母必须大写，至少包含一个字母或数字） 或 （11位数字）
    fiscalCode: {
        regular: /^([A-Za-z0-9]{16,16}|[0-9]{11,11})$/,
        helperText: 'input_rule_text_please_enter_x_numbers_or_letters_at_least_y_numbers_or_letters',
        i18nRule: { x: 16, y: 11 }
    },
    pec: {
        // eslint-disable-next-line
        regular: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
        helperText: 'input_rule_text_required'
    },
    // 网址
    website: {
        // eslint-disable-next-line
        regular: /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/,
        helperText: 'input_rule_text_required'
    },
    name2: {
        regular: /(^$|^([A-Za-z0-9\u4e00-\u9fa5\-_]+\\s?)*[A-Za-z0-9\u4e00-\u9fa5\-_]$)/,
        helperText: 'input_rule_text_required'
    },
    // 至少有一位
    required: {
        regular: /^.+$/,
        helperText: 'input_rule_text_required'
    },
    // 至少有一位
    dishName: {
        regular: /^([A-Za-z0-9\u4e00-\u9fa5\-_]+\\s?)*[A-Za-z0-9\u4e00-\u9fa5\-_]$/,
        helperText: 'forbid_entering_special_characters'
    },
    // 轮次规则相关(每轮次分钟 | 每回合点菜数 | 最大回合数)
    roundRules: {
        regular: /^([1-9][0-9]{0,3})$/,
        helperText: 'input_rule_text_must_be_an_integer_greater_than_1_and_less_than_9999'
    },
    // 匹配空字符
    emptyString: {
        regular: /^[\s]*$/,
        helperText: 'can_not_be_empty'
    },
    // 名称正则 (中间可以含有空格)
    emptyName: {
        regular: /^([A-Za-z0-9\u4e00-\u9fa5]+\s?)*[A-Za-z0-9\u4e00-\u9fa5]$/,
        helperText: 'input_rule_text_starts_with_letters_numbers_Chinese_contain_space_symbols_middle'
    },
    // 限制只能输入1-30位字符
    inputLimit: {
        regular: /^.{1,30}$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character',
        i18nRule: { x: 1, y: 30 }
    },
    // 限制只能输入1-120位字符
    inputLimit120: {
        regular: /^.{1,120}$/,
        helperText: 'input_rule_text_please_enter_x_y_characters_of_any_character',
        i18nRule: { x: 1, y: 120 }
    },
    // 图片校验
    imageCheck: {
        regular: /image\/\w+/,
        helperText: 'input_rule_text_please_upload_the_correct_picture_format'
    },
    // 最少一个字符必须是数字、英文字母或下划线
    lessOne: {
        regular: /^\w+$/,
        helperText: 'input_rule_text_please_enter_at_least_x_number_english_letter_or_underscore',
        i18nRule: { x: 1 }
    },
    // 最大6位置数字
    maxNumberSix: {
        regular: /^\d{0,6}$/,
        helperText: 'input_rule_text_please_enter_x_y_digit_characters',
        i18nRule: { x: 0, y: 6 }
    },
    /**
     * 校验餐厅税务信息公司名称规则
     * @description 允许字符：0-9a-zA-Z 和英文符号：空格 , . _ - & ( )'/|\
     * @description 注释：空格，逗号，句号，下横杠，中横杠，连接符，括号，反括号
     */
    regName: {
        regular: /^[a-zA-Z0-9 ,._&()-\\'\\/\\|\\]{1,}$/,
        helperText: 'input_rule_text_at_least_x_character_it_must_be_a_number_letter_or_symbol',
        i18nRule: { x: 1 }
    },
    // 西班牙： reg_municipality、reg_city、reg_local^( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$ （长度：1-120）
    regNameSpain120: {
        regular: /^( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$/,
        helperText: 'input_rule_text_error_reg_name_spain_x_y',
        i18nRule: { x: 1, y: 120 }
    },
    // 西班牙： reg_street_number^( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$ （长度：1-20）
    regNameSpain20: {
        regular: /^( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$/,
        helperText: 'input_rule_text_error_reg_name_spain_x_y',
        i18nRule: { x: 1, y: 20 }
    },
    // 西班牙： reg_postcode  ^( *[0-9A-Za-z.\-_/] *)*$（长度：1-20）
    regPostcode: {
        regular: /^( *[0-9A-Za-z.\-_/] *)*$/,
        helperText: 'input_rule_text_error_reg_postcode',
    },
    // 西班牙： reg_name ^( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$ （长度：3-120）
    regNameSpain03120: {
        regular: /^(?=.{3,120}$)( *[0-9A-Za-zñÑáÁàÀãÃäÄéÉèÈëËíÍïÏóÓòÒõÕØøöÖúÚüÜĿŀçÇ°ºª·.,()\-_/&ß'´] *)*$/,
        helperText: 'input_rule_text_error_reg_name_spain_x_y',
        i18nRule: { x: 3, y: 120 }
    },

    // 菜名1
    // - 0-9, a-z, A-Z, 空格, -, (, ), $, 
    dishNameAndNlu2: {
        // eslint-disable-next-line
        regular: /^[A-Za-z0-9\s\-\(\)\.\$\,]*$/,
        helperText: 'input_rule_text_please_enter_numbers_or_letters_or_dashes_or_brackets'
    },
    // 菜名，助记码
    // - 0-9, a-z, A-Z, 空格, -, (, ), $, . 中文
    dishNameAndNlu: {
        regular: /^[A-Za-z0-9\u4e00-\u9fa5\s\-().$,]*$/,
        helperText: 'input_rule_text_please_enter_numbers_or_letters_or_dashes_or_brackets2'
    },
    // ip地址加端口号
    ipAndPort: {
        regular: /^$|(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[0-9]{1,2})(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[0-9]{1,2})){3}:\d{1,5}$/,
        helperText: 'input_rule_text_ip_with_port'
    },

    // 百分比 : 0到100之间的数字，支持最多两位小数，包含0,100
    discount: {
        regular: /^(100|[1-9]?[0-9](\.\d{1,2})?)$/,
        helperText: 'input_rule_text_please_enter_number_with_up_two_decimal_places',
        i18nRule: { x: 2 }
    },
    // 金额：大于等于0的数字，支持最多2位小数，最多11位数字
    price: {
        regular: /^(0|[1-9]\d{0,10})(\.\d{1,2})?$/,
        helperText: 'input_rule_text_please_enter_number_with_up_two_decimal_places',
        i18nRule: { x: 11 }
    },
    // 正整数： 1-200的正整数，包含200
    customYear: {
        regular: /^([1-9][0-9]?|1[0-9]{2}|200)$/,
        helperText: 'input_rule_text_please_enter_number_min_1_max_200'
    },

    /** 西班牙纳税人识别号 NIF（与 RBP2 `fiskalyNif` 一致，用于 DIS 税务校验） */
    fiskalyNif: {
        regular: /^(([A-Za-z][0-9]{7}[A-Za-z])|([0-9]{8}[A-Za-z])|([A-Za-z][0-9]{8}))$/,
        helperText: ''
    },
    // 服务器地址ip
    ip: {
        regular: /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[0-9])\.((1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){2}(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/,
        helperText: 'input_rule_text_must_be_ip'
    },
};
export default BASE_CHECK_TYPE;

/**
 * 检查正则
 * - 配合BASE_CHECK_TYPE
 */
export function CheckRule(key: string, value: string) {
    const item = BASE_CHECK_TYPE[key];
    if (item) {
        if (item?.regular.test(String(value))) {
            return true
        }
    }
    return false
}


// 不同的国家使用不同的增值税号正则
export const COUNTRY_VAT_REGULAR: { [key: string]: string } = {
    '+39': 'vatNumber', // 意大利
    '+34': 'spainVatNumber', // 西班牙
};

// 不同国家使用不同的 reg_city正则、reg_local正则、
export const COUNTRY_REG_CITY_REGULAR: { [key: string]: string } = {
    '+39': 'regName', // 意大利
    '+34': 'regNameSpain120', // 西班牙
};
// 不同国家使用不同的 reg_postcode正则
export const COUNTRY_REG_POSTCODE_REGULAR: { [key: string]: string } = {
    '+39': 'regName', // 意大利
    '+34': 'regPostcode', // 西班牙
};
// 不同国家使用不同的 reg_name正则
export const COUNTRY_REG_NAME_REGULAR: { [key: string]: string } = {
    '+39': 'regName', // 意大利
    '+34': 'regNameSpain03120', // 西班牙
};
